import { AuthenticationService } from '@/services/authentication.service';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { User, UsersService } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';
import { ProfileUpdateDialogComponent } from '../profile-update-dialog/profile-update-dialog.component';
import { AddressFormComponent } from '../ui-forms/address-form/address.component';
import { InputComponent } from '../ui-forms/input/input.component';

export class userDeleteDialogData {
  user: User;
}

@Component({
  selector: 'app-user-delete-dialog',
  standalone: true,
  templateUrl: './user-delete-dialog.component.html',
  styleUrl: './user-delete-dialog.component.scss',
  imports: [
    ModalBaseComponent,
    NgTemplateOutlet,
    MatDialogModule,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    AddressFormComponent,
    InputComponent
  ]
})
export class UserDeleteDialogComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup;
  dialogTitle: string;
  loading = false;

  addressLegend: string;
  sub = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: userDeleteDialogData,
    private fb: UntypedFormBuilder,
    private userService: UsersService,
    public dialogRef: MatDialogRef<ProfileUpdateDialogComponent>,
    private authenticationService: AuthenticationService
  ) {
    this.dialogTitle = 'Suppression de votre compte';
  }

  get form_reason() {
    return this.form.get('reason') as FormControl<string>;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      reason: [null, [Validators.required, Validators.maxLength(255)]]
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;

      this.sub = this.userService.deleteUser(this.data.user.uid, { reason: this.form_reason.value }).subscribe({
        next: () => {
          this.authenticationService.logout('Votre compte a été supprimé');
          this.dialogRef.close(true);
        },
        error: () => {
          this.loading = false;
        }
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
